import React, { useState } from 'react';

import cn from 'classnames';

import IconFemtasy from 'components/IconFemtasy';

import { useTracking } from 'hooks/useTracking';

import palette from 'styles/base/palette.module.scss';

export interface IProps {
  children: React.ReactNode;
  className?: string;
  contentClassName?: string;
  opacity?: number;
  trackingName?: string;
  onClose?: () => any;
}

const Popup = ({
  children,
  className,
  contentClassName,
  opacity = 70,
  trackingName,
  onClose,
}: IProps) => {
  const { trackContentInteraction } = useTracking();

  const [hidden, setHidden] = useState<boolean>(false);

  const hide = () => {
    setHidden(true);
  };

  if (hidden) {
    return null;
  }

  const hex = palette.darkBody.replace('#', '');
  const normalizedHex =
    hex.length === 3
      ? hex
          .split('')
          .map((char) => char + char)
          .join('')
      : hex;
  const r = parseInt(normalizedHex.slice(0, 2), 16);
  const g = parseInt(normalizedHex.slice(2, 4), 16);
  const b = parseInt(normalizedHex.slice(4, 6), 16);

  return (
    <div
      className={cn('Popup fixed inset-0 z-[2000]', className)}
      style={{
        backgroundColor: `rgba(${r}, ${g}, ${b}, ${opacity / 100})`,
      }}
    >
      <div className="modal__wrapper flex items-center h-full overflow-scroll">
        <div
          className={cn(
            'content items-center text-white rounded-[16px] flex flex-col mx-auto max-w-[346px] p-4 pb-8 w-[90%]',
            contentClassName || 'bg-dark-body',
          )}
        >
          <div
            className="close flex justify-end w-full mb-2 hover:cursor-pointer"
            onClick={() => {
              if (trackingName)
                trackContentInteraction('close', 'modals', trackingName);

              hide();
              onClose && onClose();
            }}
          >
            <IconFemtasy icon="Cancel" color="white" />
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Popup;
